/**
 * `icon`: kérdés ikon a teljes GYIK oldalon és a főoldali előnézetben (opcionális).
 * `category`: szűrés a `/gyik` oldalon; azonosítók a `FAQ_CATEGORY_DEFS`-ben.
 */
/** Összevonva, hogy a /gyik szűrősor egy sorban maradjon (Összes + 4 témakör). */
export const FAQ_CATEGORY_DEFS = [
  { id: 'arajanlat', label: 'Árajánlat, díjak', cardIcon: 'tag' },
  { id: 'nemzetkozi', label: 'Nemzetközi szállítás', cardIcon: 'globe' },
  { id: 'butor_csomag', label: 'Bútorok, csomagolás', cardIcon: 'layers' },
  { id: 'nagy_spec', label: 'XXL, flotta, speciális', cardIcon: 'truck' },
];

export const FAQS = [
  {
    q: 'Mennyi idővel előre kell árajánlatot kérnem?',
    a: 'Rövid határidővel is dolgozunk, de a szabad kapacitás miatt érdemes legalább 3–5 nappal a tervezett fuvar előtt ajánlatot kérni.',
    icon: 'clock',
    category: 'arajanlat',
  },
  {
    q: 'Vállaltok nemzetközi költöztetést is?',
    a: 'Igen, belföldi és nemzetközi költöztetést is vállalunk, EU-n belüli fuvarokkal, rész- és komplett rakománnyal.',
    icon: 'globe',
    category: 'nemzetkozi',
  },
  {
    q: 'Hogyan védi a csapat az antik bútorokat és műtárgyakat?',
    a: 'Speciális csomagolóanyagokat használunk (pl. buborékfólia, takarók, sarkvédők), és a rögzítésnél külön figyelmet fordítunk az érzékeny felületekre.',
    icon: 'box',
    category: 'butor_csomag',
  },
  {
    q: 'Tudtok segíteni a rakodásban is?',
    a: 'Igen, sofőrjeink igény esetén a rakodásban is segítenek – ezt az ajánlatkérésnél érdemes jelezni.',
    icon: 'shield',
    category: 'butor_csomag',
  },
  {
    q: 'Hogyan tudom nyomon követni az XXL csomagomat?',
    a: 'Az XXL csomag nyomon követéséhez külön telefonszámot biztosítunk, ahol kollégáink pontos információt adnak az aktuális státuszról.',
    icon: 'phone',
    category: 'nagy_spec',
  },
  {
    q: 'Milyen járműparkkal dolgoztok?',
    a: '21 m³ (10 EU raklap) és 15 m³ zárt furgon kivitelű saját járműveink vannak, valamint alvállalkozó partnerekkel szükség esetén nagyobb méretű járműveket is biztosítunk.',
    icon: 'truck',
    category: 'nagy_spec',
  },
  {
    q: 'Veszélyes vagy hűtött áru szállítása is megoldható?',
    a: 'Bizonyos feltételek mellett tudunk speciális, hűtést igénylő vagy különösen kényes árut is szállítani. Erről minden esetben egyedi egyeztetés szükséges.',
    icon: 'thermometer',
    category: 'nagy_spec',
  },
];

